import { GoogleMapsModule } from '@angular/google-maps';
import { NgModule } from '@angular/core';
// registerLocaleData(localeAr);
import { CommonModule } from '@angular/common';

// Helpers
import { FormsModule } from '@angular/forms';



import { RecaptchaModule, RecaptchaSettings, RECAPTCHA_LANGUAGE, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { environment } from "public/environments/environment";
import { SubmitReasonComponent } from './components/submit-reason/submit-reason.component';
import { CustomTreeComponent } from './components/custom-tree/custom-tree.component';
import { SharedLibModule } from 'projects/shared/src/lib/shared-lib.module';
import { DirtyCheckGuard } from 'projects/shared/src/helpers/CanDeactivate/dirty-check.guard';
import { AddUserFormComponent } from './components/add-user-form/add-user-form.component';
import { ConsumerAmbassadorsProfileComponent } from './components/consumer-ambassadors-profile/consumer-ambassadors-profile.component';
import { MembershipCardComponent } from './components/consumer-ambassadors-profile/membership-card/membership-card.component';
import { SubscriptionHistoryComponent } from './components/consumer-ambassadors-profile/subscription-history/subscription-history.component';
import { WorkExperiencesComponent } from './components/consumer-ambassadors-profile/work-experiences/work-experiences.component';
import { EducationalQualificationsComponent } from './components/consumer-ambassadors-profile/educational-qualifications/educational-qualifications.component';
import { CvResumeComponent } from './components/consumer-ambassadors-profile/cv-resume/cv-resume.component';
import { EducationalQualificationsFormComponent } from './components/consumer-ambassadors-profile/educational-qualifications/educational-qualifications-form/educational-qualifications-form.component';
import { VolunteeringExperiencesFormComponent } from './components/consumer-ambassadors-profile/volunteering-experiences/volunteering-experiences-form/volunteering-experiences-form.component';
import { WorkExperiencesFormComponent } from './components/consumer-ambassadors-profile/work-experiences/work-experiences-form/work-experiences-form.component';
import { CvResumeFormComponent } from './components/consumer-ambassadors-profile/cv-resume/cv-resume-form/cv-resume-form.component';
import { AmbassadorPromotionLevelComponent } from './components/consumer-ambassadors-profile/ambassador-promotion-level/ambassador-promotion-level.component';
import { VolunteeringExperiencesComponent } from './components/consumer-ambassadors-profile/volunteering-experiences/volunteering-experiences.component';
import { CreateUserModelComponent } from './components/create-user-model/create-user-model.component';
import { MessageCommentsComponent } from './components/message-comments/message-comments.component';
import { TimeDiffPipe } from '../helpers/time-left.pipe';
import { provideNativeDateAdapter } from '@angular/material/core';
import { DownloadDirective } from '../helpers/download.directive';
// import { NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { GoogleLocationComponent } from './components/google-location/google-location.component';
import { EvaluationTaskStatusComponent } from './components/evaluation-tasks/evaluation-task-status/evaluation-task-status.component';
import { EvaluationTaskLogsComponent } from './components/evaluation-tasks/evaluation-task-logs/evaluation-task-logs.component';
import { EvaluationTaskCommentsComponent } from './components/evaluation-tasks/evaluation-task-comments/evaluation-task-comments.component';
import { CommentControlsComponent } from './components/evaluation-tasks/evaluation-task-comments/comment-controls/comment-controls.component';
import { EvaluationTaskActionsComponent } from './components/evaluation-tasks/evaluation-task-actions/evaluation-task-actions.component';
import { EvaluationTaskSurveyComponent } from './components/evaluation-tasks/evaluation-task-survey/evaluation-task-survey.component';
import { PriceMonitoringTaskStatusComponent } from './components/price-monitoring-tasks/price-monitoring-task-status/price-monitoring-task-status.component';
import { PriceMonitoringTaskPriorityComponent } from './components/price-monitoring-tasks/price-monitoring-task-priority/price-monitoring-task-priority.component';
import { CountdownModule } from 'ngx-countdown';
import { OneTimePasswordComponent } from './components/one-time-password/one-time-password.component';
import { SignatureFormComponent } from './components/signature-form/signature-form.component';
import { SignaturePadModule } from 'angular2-signaturepad';
import { PriceMonitoringTaskLogsComponent } from './components/price-monitoring-tasks/price-monitoring-task-logs/price-monitoring-task-logs.component';
import { PriceMonitoringTasksActionsComponent } from './components/price-monitoring-tasks/price-monitoring-tasks-actions/price-monitoring-tasks-actions.component';
import { MonitorTaskProductsComponent } from './components/price-monitoring-tasks/monitor-task-products/monitor-task-products.component';
import { PriceMonitoringTasksCommentsComponent } from './components/price-monitoring-tasks/price-monitoring-tasks-comments/price-monitoring-tasks-comments.component';
import { PriceMonitoringTasksCommentsControlComponent } from './components/price-monitoring-tasks/price-monitoring-tasks-comments/price-monitoring-tasks-comments-control/price-monitoring-tasks-comments-control.component';
import { MonitorPriceFormComponent } from './components/price-monitoring-tasks/monitor-price-form/monitor-price-form.component';
import { PriceMonitoringTasksFilePreviewComponent } from './components/price-monitoring-tasks/price-monitoring-tasks-file-preview/price-monitoring-tasks-file-preview.component';
import { CalenderViewComponent } from './components/calender-view/calender-view.component';
import { CalenderViewHeaderComponent } from './components/calender-view/calender-view-header/calender-view-header.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { TreeFieldComponent } from './components/tree-field/tree-field.component';
import { VerificationTaskStatusComponent } from './components/verification-tasks/verification-task-status/verification-task-status.component';
import { VerificationTaskPriorityComponent } from './components/verification-tasks/verification-task-priority/verification-task-priority.component';
import { VerificationTaskActionsComponent } from './components/verification-tasks/verification-task-actions/verification-task-actions.component';
import { VerificationTaskCommentsComponent } from './components/verification-tasks/verification-task-comments/verification-task-comments.component';
import { VerificationTaskLogsComponent } from './components/verification-tasks/verification-task-logs/verification-task-logs.component';
import { VerificationTaskSurveyComponent } from './components/verification-tasks/verification-task-survey/verification-task-survey.component';
import { VerificationConfirmEscalationComponent } from './components/verification-tasks/verification-confirm-escalation/verification-confirm-escalation.component';
import { ProductEvaluationTaskStatusComponent } from './components/product-evaluation-tasks/product-evaluation-task-status/product-evaluation-task-status.component';
import { ProductEvaluationTaskPriorityComponent } from './components/product-evaluation-tasks/product-evaluation-task-priority/product-evaluation-task-priority.component';
import { ProductEvaluationTaskActionsComponent } from './components/product-evaluation-tasks/product-evaluation-task-actions/product-evaluation-task-actions.component';
import { ProductEvaluationTaskCommentsComponent } from './components/product-evaluation-tasks/product-evaluation-task-comments/product-evaluation-task-comments.component';
import { ProductEvaluationTaskLogsComponent } from './components/product-evaluation-tasks/product-evaluation-task-logs/product-evaluation-task-logs.component';
import { ProductsEvaluationTaskComponent } from './components/product-evaluation-tasks/products-evaluation-task/products-evaluation-task.component';
import { ProductEvaluationTaskTypeComponent } from './components/product-evaluation-tasks/product-evaluation-task-type/product-evaluation-task-type.component';
import { ProductEvaluationResultComponent } from './components/product-evaluation-tasks/product-evaluation-result/product-evaluation-result.component';
import { ProductEvaluationTasksSurveyComponent } from './components/product-evaluation-tasks/product-evaluation-tasks-survey/product-evaluation-tasks-survey.component';
import { EvaluationTaskPriorityComponent } from './components/evaluation-tasks/evaluation-task-priority/evaluation-task-priority.component';
import { FraudMonitoringTasksPriorityComponent } from './components/fraud-monitoring-tasks/fraud-monitoring-tasks-priority/fraud-monitoring-tasks-priority.component';
import { FraudMonitoringTasksStatusComponent } from './components/fraud-monitoring-tasks/fraud-monitoring-tasks-status/fraud-monitoring-tasks-status.component';
import { FraudMonitoringTasksSurveyComponent } from './components/fraud-monitoring-tasks/fraud-monitoring-tasks-survey/fraud-monitoring-tasks-survey.component';
import { FraudMonitoringTasksActionsComponent } from './components/fraud-monitoring-tasks/fraud-monitoring-tasks-actions/fraud-monitoring-tasks-actions.component';
import { FraudMonitoringTasksCommentsComponent } from './components/fraud-monitoring-tasks/fraud-monitoring-tasks-comments/fraud-monitoring-tasks-comments.component';
import { FraudMonitoringTasksLogsComponent } from './components/fraud-monitoring-tasks/fraud-monitoring-tasks-logs/fraud-monitoring-tasks-logs.component';
import { FraudMonitoringTasksCommentControlsComponent } from './components/fraud-monitoring-tasks/fraud-monitoring-tasks-comments/fraud-monitoring-tasks-comment-controls/fraud-monitoring-tasks-comment-controls.component';
import { FraudConfirmEscalationComponent } from './components/fraud-monitoring-tasks/fraud-confirm-escalation/fraud-confirm-escalation.component';
import { PublishMonitoredFraudTaskComponent } from './components/fraud-monitoring-tasks/publish-monitored-fraud-task/publish-monitored-fraud-task.component';
import { BranchesTreeComponent } from './components/branches-tree/branches-tree.component';
import { OfferStatusComponent } from './components/offers/offer-status/offer-status.component';
import { OfferTypeComponent } from './components/offers/offer-type/offer-type.component';
import { SurveysRequestsTargetAudienceGenderComponent } from './components/surveys-tasks/surveys-requests-target-audience-gender/surveys-requests-target-audience-gender.component';
import { SurveyRequestTypeComponent } from './components/surveys-tasks/survey-request-type/survey-request-type.component';
import { SurveyTasksCommentControlsComponent } from './components/surveys-tasks/survey-tasks-comments/survey-tasks-comment-controls/survey-tasks-comment-controls.component';
import { SurveyTasksCommentsComponent } from './components/surveys-tasks/survey-tasks-comments/survey-tasks-comments.component';
import { SurveyTasksLogsComponent } from './components/surveys-tasks/survey-tasks-logs/survey-tasks-logs.component';
import { SurveyTasksPriorityComponent } from './components/surveys-tasks/survey-tasks-priority/survey-tasks-priority.component';
import { SurveyTasksStatusComponent } from './components/surveys-tasks/survey-tasks-status/survey-tasks-status.component';
import { SurveysTasksGeographicScopeComponent } from './components/surveys-tasks/surveys-tasks-geographic-scope/surveys-tasks-geographic-scope.component';
import { SurveyTasksActionsComponent } from './components/surveys-tasks/survey-tasks-actions/survey-tasks-actions.component';
import { SurveysTasksAnswersResponsesComponent } from './components/surveys-tasks/surveys-tasks-answers-responses/surveys-tasks-answers-responses.component';
import { AmbassadorSurveysTasksAddResponseComponent } from './components/surveys-tasks/surveys-tasks-answers-responses/ambassador-surveys-tasks-add-response/ambassador-surveys-tasks-add-response.component';
import { SurveysTasksSurveyFormComponent } from './components/surveys-tasks/surveys-tasks-survey-form/surveys-tasks-survey-form.component';
import { SurveysTasksResponseDetailsComponent } from './components/surveys-tasks/surveys-tasks-response-details/surveys-tasks-response-details.component';
import { RunAiProcessComponent } from './components/price-monitoring-tasks/price-monitoring-tasks-actions/run-ai-process/run-ai-process.component';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import { ChatComponent } from '../../../../shared/src/modules/courses/chat/chat.component';
import { QuizTypeComponent } from './components/quiz-type/quiz-type.component';
import { RespondentMessageComponent } from './components/quiz-type/respondent-message/respondent-message.component';
import { QuestionsFormComponent } from './components/quiz-type/questions-form/questions-form.component';
import { JitsiMeetingComponent } from './components/jitsi-meeting/jitsi-meeting.component';

const directives = [
  TimeDiffPipe,
  DownloadDirective,
];

const Components = [

  SubmitReasonComponent,
  CustomTreeComponent,
  ConsumerAmbassadorsProfileComponent,
  MembershipCardComponent,
  SubscriptionHistoryComponent,
  WorkExperiencesComponent,
  EducationalQualificationsComponent,
  CvResumeComponent,
  EducationalQualificationsFormComponent,
  WorkExperiencesFormComponent,
  VolunteeringExperiencesFormComponent,
  CvResumeFormComponent,
  AmbassadorPromotionLevelComponent,
  VolunteeringExperiencesComponent,
  CreateUserModelComponent,
  MessageCommentsComponent,
  GoogleLocationComponent,
  BranchesTreeComponent,

  // concourl
  OneTimePasswordComponent,
  SignatureFormComponent,
  CalenderViewComponent,
  CalenderViewHeaderComponent,

  // evaluation tasks
  EvaluationTaskStatusComponent,
  EvaluationTaskLogsComponent,
  EvaluationTaskCommentsComponent,
  CommentControlsComponent,
  EvaluationTaskActionsComponent,
  EvaluationTaskSurveyComponent,
  EvaluationTaskPriorityComponent,

  // Monitor tasks
  PriceMonitoringTaskStatusComponent,
  PriceMonitoringTaskPriorityComponent,
  PriceMonitoringTaskLogsComponent,
  PriceMonitoringTasksActionsComponent,
  PriceMonitoringTasksCommentsComponent,
  PriceMonitoringTasksCommentsControlComponent,
  MonitorPriceFormComponent,
  MonitorTaskProductsComponent,
  RunAiProcessComponent,
  TreeFieldComponent,

  // verification tasks
  VerificationTaskStatusComponent,
  VerificationTaskPriorityComponent,
  VerificationTaskActionsComponent,
  VerificationTaskCommentsComponent,
  VerificationTaskLogsComponent,
  VerificationConfirmEscalationComponent,

  // product evaluation tasks
  ProductEvaluationTaskStatusComponent,
  ProductEvaluationTaskPriorityComponent,
  ProductEvaluationTaskActionsComponent,
  ProductEvaluationTaskCommentsComponent,
  ProductEvaluationTaskLogsComponent,
  ProductsEvaluationTaskComponent,
  ProductEvaluationTaskTypeComponent,
  ProductEvaluationResultComponent,

  // Fraud Monitoring Tasks
  FraudMonitoringTasksPriorityComponent,
  FraudMonitoringTasksStatusComponent,
  FraudMonitoringTasksSurveyComponent,
  FraudMonitoringTasksActionsComponent,
  FraudMonitoringTasksCommentsComponent,
  FraudMonitoringTasksLogsComponent,
  FraudConfirmEscalationComponent,
  PublishMonitoredFraudTaskComponent,

  // offers
  OfferStatusComponent,
  OfferTypeComponent,

  // Survey Request
  SurveyRequestTypeComponent,
  SurveysRequestsTargetAudienceGenderComponent,
  SurveyTasksStatusComponent,
  SurveyTasksPriorityComponent,
  SurveyTasksLogsComponent,
  SurveyTasksCommentsComponent,
  SurveyTasksCommentControlsComponent,
  SurveysTasksGeographicScopeComponent,
  SurveyTasksActionsComponent,
  SurveysTasksAnswersResponsesComponent,
  AmbassadorSurveysTasksAddResponseComponent,
  SurveysTasksResponseDetailsComponent,

  //For courses
  QuizTypeComponent,
  RespondentMessageComponent,
  QuestionsFormComponent,

  // mettings
  JitsiMeetingComponent
];

@NgModule({
  declarations: [
    Components,
    AddUserFormComponent,
    PriceMonitoringTasksFilePreviewComponent,
    VerificationTaskSurveyComponent,
    ProductEvaluationTasksSurveyComponent,
    FraudMonitoringTasksCommentControlsComponent,
    SurveysTasksSurveyFormComponent,

  ],
  imports: [
    CommonModule,
    // RecaptchaModule,
    SharedLibModule,
    // NgxMatDatetimePickerModule,
    // NgxMatTimepickerModule,
    // NgxMatNativeDateModule,
    directives,
    GoogleMapsModule,
    CountdownModule,
    SignaturePadModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    LottieComponent
  ],
  exports: [
    // RecaptchaModule,
    directives,
    Components,
    SharedLibModule,
    CountdownModule,
    LottieComponent
    // NgxMatDatetimePickerModule,
    // NgxMatTimepickerModule,
    // NgxMatNativeDateModule,
  ],
  providers: [
    provideLottieOptions({ player: () => import('lottie-web') }),
    provideNativeDateAdapter(),
    // DatePipe,
    // { provide: LOCALE_ID, useValue: localStorage.getItem('language') === 'ar' ? 'ar-EG' : 'en-US' },
    // DirtyCheckGuard,
    // {
    //   provide: RECAPTCHA_SETTINGS,
    //   useValue: {
    //     siteKey: environment.googleSiteKey,
    //     useValue: localStorage.getItem('language') || 'ar'
    //   } as RecaptchaSettings,
    // },
    // {
    //   provide: RECAPTCHA_LANGUAGE,
    //   useFactory: () => localStorage.getItem('language') || 'ar',
    // }
  ]
})
export class SharedModule { }
